export function containsType(type) {
  const user = JSON.parse(localStorage.getItem("user"));
  return user.userType.includes(type);
}

export function getCurrentUser() {
  return JSON.parse(localStorage.getItem("user"));
}